/**
 * useReviews
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import ReviewsContext from './reviews-context'

const useReviews = () => {
  const context = useContext(ReviewsContext)
  return context
}

export default useReviews
